// Copyright (c) 2023 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import DuplicatePinPlateCellRenderer from '../../shared/report-cell-renderers/duplicate-pin-plate-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getDuplicatePinPlateColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: DuplicatePinPlateCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'dateSubmmited',
            field: 'dateSubmmited',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DATE_SUBMITTED'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'machineModel',
            field: 'machineModel',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MACHINE_MODEL_TYPE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'requesterTCSM',
            field: 'requesterTCSM',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REQUESTER_TCSM'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'missingPlateReason',
            field: 'missingPlateReason',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REASON_FOR_MISSING_PLATE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'account',
            field: 'account',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ACCOUNT'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'mailingRecipient',
            field: 'mailingRecipient',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('RECIPIENT_DEALER_OR_TCSM'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'address1',
            field: 'address1',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ADDRESS_LINE1'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'address2',
            field: 'address2',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ADDRESS_LINE2'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'city',
            field: 'city',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CITY'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'state',
            field: 'state',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STATE_PROVINCE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'postalCode',
            field: 'postalCode',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('POSTAL_CODE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'country',
            field: 'country',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('COUNTRY'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'phone',
            field: 'phone',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PHONE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'instruction',
            field: 'instruction',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('SPECIAL_INSTRUCTIONS'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'approverRemark',
            field: 'approverRemark',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('APPROVAL_REMARKS'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'status',
            field: 'status',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('APPROVAL_STATUS'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'factoryName',
            field: 'factoryName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('FACTORY_NAME'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'factory',
            field: 'factory',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('FACTORY'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'approvedBy',
            field: 'approvedBy',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('APPROVER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'shippingId',
            field: 'shippingId',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('SHIPPING_ID'),
            width: 200
        }

    ];

}



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/report-services/column-definitions.js